/**
 * Brand raster assets: the wordmark in the nav, and the Synthia mark seated
 * inside the pipeline diagram's hub.
 */

/** Dark wordmark — nav and any light surface. */
export const LOGO_SRC = 'https://cdn.magicpatterns.com/uploads/9KVFsaTMiCUuyim7KM4t3f/MeetSynthia-Logo-Dark.png'

/** The standalone mark, used at the centre of the pipeline diagram. */
export const HUB_SRC = 'https://cdn.magicpatterns.com/uploads/dtbSEaK4JWieiZPYcoTyP4/MeetSynthia-mark.png'

/**
 * Vector version of the mark, with real transparency. Used for the favicon
 * export, where the raster's white matte would show as a grey square.
 */
export const MARK_SVG = 'https://cdn.magicpatterns.com/uploads/oBojyGEB2LQTAgxMeDtUYY/newest_final_synthia_darkall_4_copy.svg'
